import React from 'react';

const About = () => {
    return (
        <section id="about">
            <div className="about-flex">
                <div className="about-img-wrap">
                    <img
                         src="/assets/images/house 1.webp" 
                        alt="Zirae Chemicals Facility"
                        className="about-img"
                    />
                </div>
                <div className="about-text">
                    <h2>ABOUT US</h2>
                    <p>Zirae Chemicals is a company born from years of experience in the chemical industry. We've grown into a brand that has turn walls & ceilings into masterpiece. We've bring precision, artistry, realiability & professionalism togther to deliver painting & pop design service that makes lasting statements.</p>
                    <p>Whether it's a family home, a growing buisness or a landmark project, our work is designed to perfection with the help of strong ad quality chemicals sourced by our team of professionals from zirae chemicals</p>
                </div>
            </div>
        </section>
    );
};

export default About;